import { forwardRef, type CSSProperties } from "react";

import { useLocalization } from "@fluent/react";
import { Chip } from "@narmi/design_system";

type FilterTypes = "year" | "type" | "account";

type DocumentFilterProps = {
  kind: FilterTypes;
  count?: number;
  onClick: () => void;
  style?: CSSProperties;
};

const DocumentFilter = forwardRef<HTMLButtonElement, DocumentFilterProps>(
  ({ kind, count, onClick, style }, ref) => {
    const { l10n } = useLocalization();
    const kindToLabelMap = {
      year: l10n.getString("document-filter-year", null, "Year"),
      type: l10n.getString("document-filter-type", null, "Document type"),
      account: l10n.getString("document-filter-account", null, "Account"),
    };

    return (
      <button
        ref={ref}
        style={style}
        onClick={onClick}
        className="button--reset"
        data-testid={`document-${kind}-filter`}
      >
        <Chip
          count={count}
          label={kindToLabelMap[kind]}
          endIcon="chevron-down"
        />
      </button>
    );
  }
);

DocumentFilter.displayName = "DocumentFilter";

export default DocumentFilter;
